var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("csm-banner"),
      _c("checkout-header"),
      !_vm.PRODUCTS.length
        ? _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "page-info",
                {
                  staticClass: "offset-page-info",
                  attrs: {
                    title: "Корзина пуста",
                    subtitle:
                      "В корзину ничего не добавлено. Чтобы добавить товары перейдите в каталог"
                  }
                },
                [
                  _c("ui-button", {
                    attrs: { text: "Начать покупки" },
                    on: { click: _vm.goHome }
                  })
                ],
                1
              )
            ],
            1
          )
        : [
            _c(
              "div",
              { staticClass: "container checkout-page" },
              [
                _c(
                  "div",
                  { staticClass: "checkout-content" },
                  [
                    _c("h1", { staticClass: "checkout-page__title" }, [
                      _vm._v("\n          Оформление заказа\n        ")
                    ]),
                    _c(
                      "vue-client-only",
                      [
                        _vm.adaptive.isMobile
                          ? _c("checkout-delivery-widget", {
                              staticClass: "checkout-page__delivery-widget"
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.isProductsUnallocated
                      ? _c("checkout-delivery", { ref: "delivery" })
                      : _vm._e(),
                    _c("checkout-products", {
                      attrs: { "cart-is-loading": _vm.CART_IS_LOADING }
                    }),
                    _c("checkout-contact", { ref: "contact" }),
                    _c("checkout-comment", {
                      staticClass: "checkout-page__comment",
                      attrs: { label: "" }
                    }),
                    _c("checkout-payment", { ref: "payment" }),
                    _c(
                      "vue-client-only",
                      [
                        !_vm.adaptive.isTablet
                          ? _c("checkout-total", {
                              attrs: { loading: _vm.submitProgress },
                              on: {
                                submit: function($event) {
                                  return _vm.submit(false)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "aside",
                  [
                    _c("vue-client-only", [
                      !_vm.adaptive.isMobile
                        ? _c(
                            "div",
                            { staticClass: "checkout-page__aside-content" },
                            [
                              _c("checkout-delivery-widget", {
                                staticClass: "checkout-page__delivery-widget",
                                attrs: { adaptive: false }
                              }),
                              _c("checkout-total-widget", {
                                on: {
                                  submit: function($event) {
                                    return _vm.submit(true)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                ),
                _c("delivery-selector")
              ],
              1
            ),
            _c("vue-client-only", [
              _vm.adaptive.isTablet
                ? _c(
                    "div",
                    { staticClass: "container checkout-page" },
                    [
                      _c("checkout-total", {
                        attrs: { loading: _vm.submitProgress },
                        on: {
                          submit: function($event) {
                            return _vm.submit(false)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ],
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.PRODUCTS.length
            ? _c("product-gallery-recomendations", {
                staticClass: "checkout-page__recomendations",
                attrs: {
                  title: "Популярные товары",
                  "product-ids": _vm.cartProductsIds
                }
              })
            : _vm._e(),
          !_vm.PRODUCTS.length
            ? _c("product-gallery-slot", {
                staticClass: "offset-recommendation-gallery",
                attrs: { "with-category": false, "slot-name": "popular_main" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.isLoading || _vm.CART_IS_LOADING
        ? _c("ui-loader", {
            staticClass: "checkout-loader",
            attrs: { size: "64" }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }